import { createContext, useContext } from "react";

export interface TabsContextProps {
  /**
   * Whether or not the entire tabs component is non-interactive.
   */
  disabled?: boolean;
  /**
   * The currently selected tab value.
   */
  value?: string;
}

export const TabsContext = createContext<TabsContextProps>({});

export function useTabsContext() {
  return useContext(TabsContext);
}
